<template>
  <div
    :class="[
      disabled ? 'disabled' : '',
      wide ? 'wide' : '',
      downArrows ? 'down-arrows' : '',
      'll-button',
      classes,
    ]"
    role="button"
    @click="$emit('click')"
  >
    <span v-if="downArrows" class="down-arrow left"><DoubleArrows /></span>
    <slot />
    <span v-if="downArrows" class="down-arrow right"><DoubleArrows /></span>
    <span v-if="arrows" class="arrows">
      <DoubleArrows />
    </span>
  </div>
</template>

<script>
import DoubleArrows from "@/assets/DoubleArrows.svg";

export default {
  name: "BaseButton",
  components: {
    DoubleArrows,
  },
  props: {
    arrows: {
      type: Boolean,
      default: false,
    },
    downArrows: {
      type: Boolean,
      default: false,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    classes: {
      type: String,
      default: "",
    },
    wide: {
      type: Boolean,
      default: false,
    },
  },
};
</script>

<style lang="scss" scoped>
.ll-button {
  background-color: $green;
  color: #ffffff;
  text-align: center;
  border-radius: 5px;
  padding: 10px 15px;
  cursor: pointer;
  transition: all 0.1s ease-in-out;
  user-select: none;
  display: inline-flex;
  justify-content: center;
  align-items: center;
  width: auto;
  box-shadow: 0px 2px 4px #bbbbbb;

  .arrows {
    display: inline-flex;
    align-items: center;
    margin-left: 10px;
  }

  .down-arrow {
    transform: rotate(90deg);
    &.left {
      display: inline-block;
      margin-right: 15px;
      font-size: 1.4em;
    }

    &.right {
      display: inline-block;
      margin-left: 15px;
      font-size: 1.4em;
    }
  }

  &.wide {
    display: flex;
    &.down-arrows {
      padding: 7px;
    }
  }

  span {
    color: #ffffff;
  }

  &:hover {
    background-color: #58bfac;
  }

  &.disabled {
    opacity: 0.7;
    cursor: default;
    &:hover {
      box-shadow: none;
    }
  }
}
</style>
